import React, { useContext } from 'react'
import { getNextItem, getPrevItem } from '@brainstud/react-helpers'
import { useSubmitQuestions } from '../store'
import QuizContext from '../QuizContext'

export default function () {
  const quiz = useContext(QuizContext)

  const progress = quiz.state.progress.quiz
  const questionsById = quiz.state.questions.byId
  const questionsallIds = quiz.state.questions.allIds

  const prevQuestion = getPrevItem(questionsallIds, questionsById, progress.question)
  const nextQuestion = getNextItem(questionsallIds, questionsById, progress.question)

  const prevQuestionTo = prevQuestion
    ? { key: 'question', value: prevQuestion.id }
    : { key: 'intro' }

  const nextQuestionTo = nextQuestion
    ? { key: 'question', value: nextQuestion.id }
    : { key: 'summary' }

  const routes = {
    intro: { prev: false, next: nextQuestionTo },
    question: { prev: prevQuestionTo, next: nextQuestionTo },
    summary: { prev: prevQuestionTo, next: false },
  }

  const prevTo = routes[progress.location || 'intro'].prev
  const nextTo = routes[progress.location || 'intro'].next

  const currentProgress = progress.location === 'summary' && quiz.state.progress.quiz.completed
    ? progress.totalQuestions
    : quiz.state.questions.allIds.indexOf(progress.question) + 1
  const totalProgress = progress.totalQuestions || 1

  const handleBack = () => {
    if (!prevTo) {
      quiz.goToRoute({ key: 'home' })
      return
    }

    quiz.goToRoute(prevTo)
  }

  const handleNext = () => {
    if (!nextTo) {
      quiz.goToRoute({ key: 'home' })
      return
    }

    if (nextTo.key === 'summary') {
      if (progress.remainingToTouch <= 0) {
        if (!progress.completed) {
          quiz.goToModal('confirm-submit', {
            onClick: () => {
              useSubmitQuestions(quiz.dispatch, data => quiz.saveData(data))
              quiz.goToRoute(nextTo)
            },
          })
          return
        }
      } else {
        quiz.goToModal('incomplete', {
          current: progress.totalQuestions - progress.remainingToTouch,
          total: progress.totalQuestions
        })
        return
      }
    }

    quiz.goToRoute(nextTo)
  }

  // nextClick = e => {
  //   if(this.nextTo) return

  //   if(this.props.quiz.endtest && this.props.progress.remainingToTouch <= 0) {
  //     if(!this.props.progress.completed) {
  //       this.props.modal.open('quiz-confirm-submit', {
  //         onClick: () => {
  //           this.props.submitQuestions(this.props.quiz.id)
  //           this.props.history.push(this.props.nextTo)
  //         },
  //       })
  //     } else {
  //       this.props.history.push(this.props.nextTo)
  //     }
  //   }

  //   if(this.props.quiz.endtest && this.props.progress.remainingToTouch > 0) {
  //     this.props.modal.open('quiz-incomplete', {
  //       current: this.props.progress.totalQuestions - this.props.progress.remainingToTouch,
  //       total: this.props.progress.totalQuestions
  //     })
  //   }

  //   if(!this.props.quiz.endtest && this.props.progress.remainingToSubmit > 0) {

  //     this.props.modal.open('quiz-incomplete', {
  //       current: this.props.progress.totalQuestions - this.props.progress.remainingToSubmit,
  //       total: this.props.progress.totalQuestions
  //     })
  //   }

  //   if(!this.props.quiz.endtest && this.props.progress.remainingToSubmit <= 0) {
  //     if(this.props.quiz.summary)
  //       this.props.history.push(this.props.nextTo)

  //     this.props.setProgress(this.props.quiz.id, {
  //       completed: true,
  //     })

  //     this.props.modal.open('quiz-results', {
  //       nextTo: this.props.nextTo,
  //       chapter: 1,
  //       score: this.props.progress.currentScore,
  //       total: this.props.progress.totalPoints,
  //     })
  //   }
  // }

  return {
    currentProgress,
    totalProgress,
    handleBack,
    handleNext,
  }
}
